import { yupResolver } from "@hookform/resolvers/yup"
import { useForm, Controller } from "react-hook-form"
import { useLocation, useNavigate } from "react-router-dom"
import SelectBox from "../../components/admin/SelectBox"
//import defaultConfig from "../../config/Config"
import { FormError } from "../../components/FormError"
import * as Yup from "yup";
import React, { useEffect, useState } from "react"
import {useDispatch, useSelector} from "react-redux"
import { getAllState, CityByState, cityPincode } from "../../slices/InitialDataSlice"
import { reset, saveBeat } from "../../slices/BeatSlice"
import { MessageModel } from "../../components/MessageModel";
export function AddBeat(){
    const locationData = useLocation()
    const successMessage = useSelector((state) => state.beats.success);
    const errorMessage = useSelector((state) => state.beats.error);
    const type = useSelector((state) => state.beats.type);
    const navigate = useNavigate();
    const { 
        StateList: stateListData, 
        CitiesList: cityListData, 
        pincodeList: pincodeListData 
    } = useSelector((state) => state.initialData)    
    const dispatch = useDispatch()
    //const { id } = useParams()
    const { 
        register, 
        handleSubmit, 
        formState: { errors }, 
        control, 
} = useForm({
        mode: "onBlur",
        resolver: yupResolver(Yup.object().shape({
            stateId: Yup.string().required("State is required"),
            cityId:  Yup.string().required("City is required"),
            pincode: Yup.string().required("Pincode is required"),
        }))
    })

    const [stateList, setStateList] = useState([])
    const [cityList, setCityList] = useState([])
    const [pincodeList, setPincodeList] = useState([]) 
    const [selectedPincode, setSelectedPincode] = useState(null)
    useEffect(() => {
        dispatch(getAllState())
    }, [dispatch])

    useEffect(() => {
        if(stateListData !== stateList){
            const list = stateListData.map((item) => {
                return {
                    label: item.name,
                    value: item._id
                }
            })
            setStateList(list)
        }

        if( cityListData){
            const list = cityListData.map((item) => {
                return {
                    label: item.name,
                    value: item._id
                }
            })
            setCityList(list)
        }

        if( pincodeListData){
            const list = pincodeListData.map((item) => {
                return {
                    label: item.pincode,
                    value: item.pincode
                }
            })
            setPincodeList(list)
        }


    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateListData, cityListData, pincodeListData])

    const onStateChange = (callback, opt)=>{
        dispatch(CityByState(opt.value))
        callback(opt.value)
    }

    const onPincodeChange = (callback, opt)=>{
        const selecPincode = pincodeListData.find((item) => item.pincode === opt)
        setSelectedPincode(selecPincode?.area)
        callback(opt)
    }

    const onSubmit = (data) => {  
        const { area, ...rest } = data
        const areasData = Object.keys(area).map((item) => {
            return  {
                areaId: item
            }
        })
        rest.area = areasData  
        dispatch(saveBeat(rest))
    }

    function onCancel(e){
        const queryString  = new URLSearchParams(locationData.state).toString()
        navigate(`/beats?${queryString}`);
        return;
    }

    const redirectToLogin = () => {
        dispatch(reset())
        if(successMessage){
          navigate("/beats")
        } 
    }
    return(    
        <React.Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-header">
                                <h4 className="card-title">Add New Beat</h4>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    {/* <div className="col-md-6">
                                        <div className="form-group mb-4">
                                            <label className={`input-lable  ${errors.name && "error"}`} htmlFor="Name">Name</label>
                                            <input 
                                                type="text" className={`input-label form-control ${
                                                    errors.name && "error"
                                                }`}     
                                                placeholder="Name" 
                                                {...register("name")} 
                                            />
                                            <FormError message={errors?.name?.message} fieldName="name" />
                                        </div>
                                    </div> */}
                                    <div className="col-md-6">
                                        <div className="form-group mb-4">
                                            <label className={`d-block ${errors.stateId && "error"}`} htmlFor="State">State</label>
                                            <Controller
                                                name="stateId"
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <SelectBox
                                                        options={stateList}
                                                        isClearable={true}
                                                        onChange={(opt) => onStateChange(onChange, opt)}
                                                        value={stateList.find(
                                                            (option) => option.value === value
                                                        )}
                                                    />
                                                )}
                                            />

                                            {errors.stateId && (
                                                <FormError message={errors.stateId.message} />
                                                )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group mb-4">
                                            <label className={`d-block ${errors.cityId && "error"}`}  htmlFor="City">City</label>
                                            <Controller
                                                name="cityId"
                                                control={control}
                                                render={({ field }) => (
                                                    <SelectBox
                                                        options={cityList}
                                                        isClearable={true}
                                                        onChange={(e) => {
                                                            field.onChange(e?.value)
                                                           dispatch(cityPincode({cityId: e?.value, extraQueryStr:{groupByPincode: true}}))
                                                        }}
                                                        value={cityList.find(
                                                            (option) => option.value === field.value
                                                        )}
                                                    />
                                                )}
                                            />
                                            {errors.cityId && (
                                                <FormError message={errors.cityId.message} />
                                                )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group mb-4">
                                            <label className={`d-block ${errors.cityId && "error"}`}  htmlFor="Pincode">Pincode</label>
                                            <Controller
                                                name="pincode"
                                                control={control}
                                                render={({ field }) => (
                                                    <SelectBox
                                                        options={pincodeList}
                                                        onChange={(e) => { onPincodeChange(field.onChange, e.value) }}
                                                    />
                                                )}
                                            />
                                            {errors.pincode && (
                                                <FormError message={errors.pincode.message} />
                                                )}
                                        </div>
                                    </div>
                                </div>
                                {
                                    selectedPincode? 
                                        <div className="row">
                                            <div className="col-sm-12 border-bottom">
                                                <h2 className="mb-1">Locations</h2>
                                            </div>
                                            <br/>
                                            <div className="col-sm-12 border-bottom mt-4">
                                                {
                                                    selectedPincode.map((item, index) => {
                                                            return  (<div key={item._id} className="form-group">
                                                                <div className="form-check">
                                                                    <input 
                                                                        {...register(`area.${item._id}`) }
                                                                        type="checkbox" 
                                                                        className="form-check-input" 
                                                                        id={`location${item._id}`}
                                                                    />
                                                                    &nbsp;&nbsp;&nbsp;
                                                                    <label className="form-check-label" htmlFor={`location${item._id}`}>{`${item.name} ${item.pincode} `}</label>
                                                                </div>
                                                            </div>)
                                                    })    
                                                }
                                                
                                            </div>
                                        </div>
                                    :'' 
                                }
                                
                            </div>
                            <div className="card-footer">
                                <div className="col-12 mb-3 text-right">
                                    <button type="submit" className="btn btn-success btn-lg mx-2">Add New Beat</button>
                                    <button type="button" onClick={onCancel} className="btn btn-danger btn-lg mx-2">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {type === 'BEAT_SAVE_SUCCESS' || type === 'BEAT_SAVE_ERROR' ? (
                <MessageModel
                    btnEvent={redirectToLogin}
                    error={errorMessage}
                    success={successMessage}
                    message = {successMessage || errorMessage}
                />
            ) : (
                ""
            )}
        </React.Fragment>


    )
}